import {
  Card,
  CardContent,
  Grid,
  Typography
} from '@mui/material';
import { React, useEffect, useState } from 'react';
import HelpIcon from '@mui/icons-material/Help';
import ReactTooltip from 'react-tooltip';

const BoxPercentageOccurrencesSolved = ({ occurrences }) => {
  const primeiro = {
    height: '140px',
    paddingTop: 5,
    backgroundColor: "#fff"
  };

  //Porcentagem de ocorrências atendidas sobre ocorrências abertas
  const [percentage, setPercentage] = useState();

  useEffect(() => {
    let occurrencesSolved = 0;
    const quantTotalOccurrences = occurrences.length;

    occurrences.forEach((occurrence) => {
      if (occurrence.status === "Resolvido" || occurrence.status === "Indeferido") occurrencesSolved++;
    });

    if (quantTotalOccurrences !== 0) {
      setPercentage((occurrencesSolved / quantTotalOccurrences * 100).toFixed(2));
    } else
      setPercentage(0);
  }, [occurrences]);

  return (
    <Card >
      <CardContent style={primeiro}>
        <Grid
          container
          spacing={1}
          sx={{ justifyContent: 'space-between' }}
        >
          <Grid item >
            <Typography
              className="box-title"
              gutterBottom
              variant="h6"
            >
              Relação Atendidas Abertas
              <HelpIcon style={{ 'color': '#a1a5ab', marginTop: -7 }} fontSize="small" data-for="proportion-info" data-place="bottom" data-tip='Indica a proporção de ocorrências Atendidas em relação ao número total de ocorrências.' />
              <ReactTooltip id="proportion-info" className='popup' />
            </Typography>

            <Typography
              color="textPrimary"
              variant="h3"
            >
              {percentage}%
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default BoxPercentageOccurrencesSolved;